import { Box, SxProps, Theme } from '@mui/material';
import React from 'react';
import { flexBase } from '../../../Constants';
import useBreakpoints from '../../../hooks/useBreakpoint';
import { ReactComponent as CdeLogo } from './cde_logo.svg';
import { ReactComponent as CdeInfrastructureLabel } from './cde_infrastructure_label.svg';
import { ReactComponent as CdeInfrastructureLabelDark } from './cde_infrastructure_label_dark.svg';
import { vars } from '../../../Theme';

/**
 * Cosmetic component that shows logo and brand.
 */
export default ({ boxSx: overrideBoxSx, darkMode }: { boxSx?: SxProps<Theme>; darkMode?: boolean }) => {
    /** Detect screen size. */
    const { isMobile, isTablet } = useBreakpoints();

    /** Styles for the logo's wrapper element. */
    const boxSx: SxProps = {
        ...flexBase,
        flexDirection: 'row',
        textAlign: 'left',
        whiteSpace: 'nowrap',
        width: isMobile ? 100 : isTablet ? 180 : 'auto',
        ...overrideBoxSx,
    };

    const labelStyle: React.CSSProperties = {
        paddingLeft: '8px',
    };

    return (
        <Box sx={boxSx}>
            <CdeLogo fill={vars.logoBlue} />
            {darkMode ? <CdeInfrastructureLabelDark style={labelStyle} /> : <CdeInfrastructureLabel style={labelStyle} />}
        </Box>
    );
};
